























import Vue from 'vue';
import { IDescriptionSectionData } from '@/common/interfaces/products.interface';
import ImageWithErrorMessage
  from '@/components/newsingleproductpage/subcomponents/imagewitherrormessage/ImageWithErrorMessage.vue';

export default Vue.extend({
  name: `DescriptionSection`,
  components: { ImageWithErrorMessage },
  props: {
    descriptionSectionData: {
      required: true,
      type: Object as () => IDescriptionSectionData,
    },
  },
});
